var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"animation"}),_c('img',{staticClass:"bg",attrs:{"src":require("../assets/Welcome.png")}})])}]

export { render, staticRenderFns }